// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._2rko1rr0{border-radius:var(--ds-radius-full,9999px)}\n._zulp1b66{gap:var(--ds-space-050,4px)}._18u01wug{margin-left:auto}\n._1bah1yb4{justify-content:space-between}\n._4cvr1h6o{align-items:center}\n._bfhk1bhr{background-color:var(--ds-surface-overlay,#fff)}\n._ca0q12x7{padding-top:var(--ds-space-075,6px)}", ""]);
// Exports
module.exports = exports;
